export class RequestQueryParams {
    ids: any[];
    queryString: {
        [key: string]: any;
    }
}




// WEBPACK FOOTER //
// ./node_modules/@rx/http/rxhttp.models.ts